<template>
	<el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false"  append-to-body>
		<el-form :model="form" :rules="rules" ref="form">
			<el-form-item label="服务器名称" :label-width="formLabelWidth" prop="dstId">
				<el-select size="medium" v-model="form.dstId" placeholder="请选择服务器">
					<el-option v-for="item in serverDeployData" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择访员" :label-width="formLabelWidth" prop="uid">
				<el-select size="medium" v-model="form.uid"  multiple collapse-tags placeholder="请选择访员">
					<el-option v-for="item in userDatas" :key="item.userId" :label="item.username" :value="item.userId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="工号" :label-width="formLabelWidth" >
				<el-col :span="11">
					<el-form-item prop="clientId"><el-input size="medium" v-model="form.clientId" autocomplete="off" placeholder="工号"></el-input></el-form-item>
				</el-col>
				<el-col class="line" :span="2" style="text-align:center;">-</el-col>
				<el-col :span="11">
					<el-form-item prop="tempclientId"><el-input size="medium" v-model="form.tempclientId" autocomplete="off" placeholder="工号"></el-input></el-form-item>
				</el-col>
			</el-form-item>
			<el-form-item label="密码" :label-width="formLabelWidth" prop="password"><el-input size="medium" v-model="form.password" autocomplete="off" placeholder="密码"></el-input></el-form-item>
			<el-form-item label="客户机IP(模拟线)" :label-width="formLabelWidth" prop="clientIp">
				<el-input size="medium" v-model="form.clientIp" autocomplete="off" placeholder="客户机IP(模拟线)"></el-input>
			</el-form-item>

			<!-- 没有生效，暂时隐藏（202060109） -->
			<!-- <el-form-item label="" :label-width="formLabelWidth" prop="isPassWord">
				<el-switch v-model="form.isPassWord"></el-switch>
				使用工号作为密码
			</el-form-item> -->
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="medium" v-loading="loading" type="primary" @click="setDetails('form')">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			serverDeployData: [],
			userDatas: [],
			value1: false,
			title: '添加服务器',
			dialogFormVisible: false,
			dialogFormVisibleType: 1, //添加编辑类型
			form: {
				dstId: '',
				uid: '',
				clientId: '',
				tempclientId: '',
				password: '',
				clientIp: '',
				isPassWord: 0
			},
			formLabelWidth: '120px',
			rules: {
				dstId: [
					{ required: true, message: '请选择服务器名称！', trigger: 'blur, change' }
				],
				uid: [
					{ required: true, message: '请选择访员！', trigger: 'blur, change' }
				],
				clientId: [
					{ required: false }
				],
				tempclientId: [
					{ required: false }
				],
				password: [
					{ required: false }
				],
				clientIp: [
					{ required: false }
				],
				isPassWord: [
					{ required: false }
				],
			},
			loading: false
		};
	},

	methods: {
		// 查询服务器
		serverDeployloadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.serverList}?pageIndex=${1}&pageSize=${10000}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.serverDeployData = res.resultBody.datas;
					} else {
						that.serverDeployData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 查询访员
		loadInterviewerUserDatas() {
			this.$api
				.InterviewerUserList(1, 10000)
				.then(data => {
					this.userDatas = data.resultBody.datas;
				})
				.catch(error => {
					console.log(error);
					if (error.message == '暂无数据') {
						this.userDatas = [];
					}
				});
		},
		resetForm(formName) {
			this.dialogFormVisible = false;
			this.$refs[formName].resetFields();
		},
		setDetails(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let that = this;
					this.loading = true
					let data = JSON.parse(JSON.stringify(that.form));

					if (data.uid.length < data.tempclientId - data.clientId ) {
						that.$message.warning('请增加工号');
						return false;
					}
					if (data.isPassWord) {
						data.isPassWord = 1;
					} else {
						data.isPassWord = 0;
					}
					data.uid = data.uid.toString();
					if (data.tempclientId == undefined) {
						data.tempclientId = '';
						data.clientId = data.clientId;
					} else {
						data.clientId = data.clientId + ',' + data.tempclientId;
					}
					console.log(data);
					let params = {
						that: this,
						url: `${this.$config.service.bindUpdate}`,
						method: 'POST',
						data: data,
						cb(res) {
							if (res.code == 0) {
								that.$emit('bindingOk');
								that.resetForm(formName)
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						},
						finally() {
							that.loading = false
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			
		},
		addDetails() {
			this.title = '添加坐席绑定';
			this.dialogFormVisibleType = 1;
			this.form = {
				id: 0
			};
			this.loadInterviewerUserDatas();
			this.serverDeployloadData();
			this.dialogFormVisible = true;
		},
		editDetails() {
			this.title = '修改坐席绑定';
			this.dialogFormVisibleType = 2;
			this.loadInterviewerUserDatas();
			this.serverDeployloadData();
			this.dialogFormVisible = true;
		}
	}
};
</script>

<style></style>
